import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    templatesListAriaLabel: string;
    templates: string;
    templateTranslationMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the templates list */
            templatesListAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplatesList.templatesListAriaLabel?c=32sf4ij7ddh59", defaultMessage: "Templates List" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Section label for templates */
            templates: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplatesList.templates?c=3hrbn30ihiw5q", defaultMessage: "Templates" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message explaining why templates are only English for now */
            templateTranslationMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TemplatesList.templateTranslationMessage?c=1k62gl8f8ybuf", defaultMessage: "Templates are currently available in English only. Additional languages will be available soon." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
